import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
/**
 * 未登录状态也可以登录的路由
 */
export var constantRoutes = [
    // mode: 'history',
    //官网业务
    // ...[
    //     {
    //         path: '/',
    //         name: 'Entrance',
    //         component: () => import('@/views/index'),
    //         meta: {
    //             title: '玩电'//'推币机-决战万圣夜-推金币-直播赚钱',
    //         }
    //     },
    //     {
    //         path: '/mobile/index',
    //         component: () => import('@/views/mobile/index'),
    //         meta: {
    //             title: '玩电'//'推币机-决战万圣夜-推金币-直播赚钱',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/share/store',
    //         component: () => import('@/views/share/store'),
    //         meta: {
    //             title: '分享店铺',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/share/dynamic',
    //         component: () => import('@/views/share/dynamic'),
    //         meta: {
    //             title: '分享动态',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/share/anchor',
    //         component: () => import('@/views/share/anchor'),
    //         meta: {
    //             title: '分享主播',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/tutorial',
    //         component: () => import('@/views/mobile/tutorial'),
    //         meta: {
    //             title: '直播教程',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/mobile/serve_agreement',
    //         component: () => import('@/views/mobile/serve_agreement'),
    //         meta: {
    //             title: '用户注册协议',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/mobile/anchor_violations',
    //         component: () => import('@/views/mobile/anchor_violations'),
    //         meta: {
    //             title: '玩电主播违规管理办法',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/pc/policy',
    //         component: () => import('@/views/pc/policy'),
    //         meta: {
    //             title: '隐私权政策',
    //         },
    //         hidden: true
    //     },
    //     {
    //         path: '/mobile/policy',
    //         component: () => import('@/views/mobile/policy'),
    //         meta: {
    //             title: '隐私权政策',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //vivo兑换码
    //         path: '/activity_center/vivo_cdkey',
    //         component: () => import('@/views/activity_center/vivo_cdkey'),
    //         hidden: true
    //     },
    //     {
    //         path: '/mobile/recharge',
    //         component: () => import('@/views/mobile/recharge'),
    //         meta: {
    //             title: '电量充值',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //主播收益
    //         path: '/mobile/earnings',
    //         component: () => import('@/views/mobile/earnings'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //提现到支付宝
    //         path: '/mobile/withdraw_list_alipay',
    //         component: () => import('@/views/mobile/withdraw_list_alipay'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //添加支付宝
    //         path: '/mobile/add_alipay_account',
    //         component: () => import('@/views/mobile/add_alipay_account'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //提现到银行卡
    //         path: '/mobile/withdraw_list_bank_card',
    //         component: () => import('@/views/mobile/withdraw_list_bank_card'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //添加银行卡
    //         path: '/mobile/add_bank_card_account',
    //         component: () => import('@/views/mobile/add_bank_card_account'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //主播收益
    //         path: '/pc/anchor_earnings',
    //         component: () => import('@/views/pc/anchor_earnings'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //主播收益
    //         path: '/mobile/anchor_earnings',
    //         component: () => import('@/views/mobile/anchor_earnings'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         //兑换电量
    //         path: '/mobile/conversion_electric',
    //         component: () => import('@/views/mobile/conversion_electric'),
    //         meta: {
    //             title: '',
    //         },
    //         hidden: true
    //     },
    //     {
    //         // 第三方SDK使用情况
    //         path: '/sdk.txt',
    //         name: 'sdk',
    //         component: () => import('@/views/sdk_txt'),
    //         meta: {
    //             title: ''
    //         }
    //     },
    // ],
    //游戏/推广业务
    // ...[
    //     //登录
    //     ...[
    //         {
    //             path: '/game/login',
    //             component: () => import('@/views/game/login/login'),
    //             meta: {
    //                 title: '登录',
    //             },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/update_password_step_1',
    //             component: () => import('@/views/game/login/update_password_step_1'),
    //             meta: {
    //                 title: '找回密码',
    //             },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/update_password_step_2',
    //             component: () => import('@/views/game/login/update_password_step_2'),
    //             meta: {
    //                 title: '设置密码',
    //             },
    //             hidden: true
    //         },
    //     ],
    //     //我的
    //     ...[      
    //         {
    //             path: '/game/my',
    //             component: () => import('@/views/game/my/index'),
    //             meta: {
    //                 title: '我的'
    //             },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/wallet',
    //             component: () => import('@/views/game/my/wallet'),
    //             // meta: {
    //             //     title: '我的钱包'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/detail',
    //             component: () => import('@/views/game/my/detail'),
    //             meta: {
    //                 title: '明细'
    //             },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/gift',
    //             component: () => import('@/views/game/my/gift'),
    //             meta: {
    //                 title: '我的礼物'
    //             },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/backpack',
    //             component: () => import('@/views/game/my/backpack'),
    //             // meta: {
    //             //     title: '我的背包'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/backpack_store',
    //             component: () => import('@/views/game/my/backpack_store'),
    //             // meta: {
    //             //     title: '我的背包'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/backpack_extract',
    //             component: () => import('@/views/game/my/backpack_extract'),
    //             // meta: {
    //             //     title: '提货'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/site',
    //             component: () => import('@/views/game/my/site/index'),
    //             // meta: {
    //             //     title: '我的地址'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/add_site',
    //             component: () => import('@/views/game/my/site/add_site'),
    //             // meta: {
    //             //     title: '添加地址'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/edit_site',
    //             component: () => import('@/views/game/my/site/edit_site'),
    //             // meta: {
    //             //     title: '修改地址'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/task',
    //             component: () => import('@/views/game/my/task/index'),
    //             // meta: {
    //             //     title: '修改地址'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/sign_in',
    //             component: () => import('@/views/game/my/sign_in'),
    //             // meta: {
    //             //     title: '签到'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/nobility',
    //             component: () => import('@/views/game/my/nobility/index'),
    //             // meta: {
    //             //     title: '我的贵族'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/nobility_info',
    //             component: () => import('@/views/game/my/nobility/info'),
    //             // meta: {
    //             //     title: '玩电贵族'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/nobility_open_up',
    //             component: () => import('@/views/game/my/nobility/open_up'),
    //             // meta: {
    //             //     title: '开通贵族'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/recharge_protocol',
    //             component: () => import('@/views/game/my/recharge_protocol'),
    //             // meta: {
    //             //     title: '充值服务协议'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/invitation_code',
    //             component: () => import('@/views/game/my/invitation_code'),
    //             // meta: {
    //             //     title: '邀请好友'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/fill_in_invitation_code',
    //             component: () => import('@/views/game/my/fill_in_invitation_code'),
    //             // meta: {
    //             //     title: '填写邀请码'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/apply_for',
    //             component: () => import('@/views/game/my/apply_for'),
    //             // meta: {
    //             //     title: '填写邀请码'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/my/binding_phone',
    //             component: () => import('@/views/game/my/binding_phone'),
    //             // meta: {
    //             //     title: '绑定手机号'
    //             // },
    //             hidden: true
    //         },
            
            
    //     ],
    //     //社区
    //     ...[
    //         {
    //             path: '/game/community',
    //             component: () => import('@/views/game/community/index'),
    //             // meta: {
    //             //     title: '动态'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/community/send',
    //             component: () => import('@/views/game/community/send'),
    //             // meta: {
    //             //     title: '发送动态'
    //             // },
    //             hidden: true
    //         },
    //         {
    //             path: '/game/community/personal',
    //             component: () => import('@/views/game/community/personal'),
    //             // meta: {
    //             //     title: '个人动态'
    //             // },
    //             hidden: true
    //         },
            
    //     ],
    //     //首页入口里面的主要业务
    //     ...[
    //         {
    //             path: '/game/home',
    //             component: () => import('@/views/game/home/index'),
    //             meta: {
    //                 title: '首页'
    //             },
    //             hidden: true
    //         },
    //         {
    //             //店铺
    //             path: '/game/store',
    //             component: () => import('@/views/game/store/info'),
    //             hidden: true
    //         },
    //         {
    //             //跳跳球
    //             path: '/game/store/product_coin_factory',
    //             component: () => import('@/views/game/store/product_coin_factory'),
    //             hidden: true
    //         },
    //         {
    //             //娃娃机
    //             path: '/game/store/product_prize_claw',
    //             component: () => import('@/views/game/store/product_prize_claw'),
    //             hidden: true
    //         },
    //         {
    //             //礼品机
    //             path: '/game/store/product_gift',
    //             component: () => import('@/views/game/store/product_gift'),
    //             hidden: true
    //         },
    //         {
    //             //浏览记录
    //             path: '/game/history',
    //             component: () => import('@/views/game/home/history'),
    //             hidden: true
    //         },
    //         {
    //             //地址定位
    //             path: '/game/location_choice',
    //             component: () => import('@/views/game/home/location_choice'),
    //             hidden: true
    //         },
    //         {
    //             //搜索
    //             path: '/game/search',
    //             component: () => import('@/views/game/home/search'),
    //             hidden: true
    //         },
    //         {
    //             //搜索结果
    //             path: '/game/search_result',
    //             component: () => import('@/views/game/home/search_result'),
    //             hidden: true
    //         },
    //         {
    //             //设备分类
    //             path: '/game/product_type',
    //             component: () => import('@/views/game/home/product_type'),
    //             hidden: true
    //         },
    //         {
    //             //拼团页面
    //             path: '/game/group_book',
    //             component: () => import('@/views/game/home/group_book'),
    //             hidden: true
    //         },
    //         {
    //             //兑换电量
    //             path: '/game/expert_announcement',
    //             component: () => import('@/views/game/home/expert_announcement'),
    //             meta: {
    //                 title: '',
    //             },
    //             hidden: true
    //         },
    //         {
    //             //客服
    //             path: '/game/service',
    //             component: () => import('@/views/game/service'),
    //             hidden: true
    //         },
    //         {
    //             //彩票中心
    //             path: '/game/lottery_center',
    //             component: () => import('@/views/game/store/lottery_center'),
    //             hidden: true
    //         },
    //         {
    //             //兑换记录
    //             path: '/game/conversion_history',
    //             component: () => import('@/views/game/store/conversion'),
    //             hidden: true
    //         },
    //         {
    //             //礼品详情
    //             path: '/game/gift_info',
    //             component: () => import('@/views/game/store/gift_info'),
    //             hidden: true
    //         },
    //         {
    //             //任务中心
    //             path: '/game/task',
    //             component: () => import('@/views/game/store/task'),
    //             hidden: true
    //         },
    //         {
    //             //店铺充值
    //             path: '/store/recharge',
    //             component: () => import('@/views/game/store/recharge'),
    //             hidden: true
    //         },
            
    //     ],
    //     //关注
    //     ...[
    //         {
    //             path: '/game/attention',
    //             component: () => import('@/views/game/attention/index'),
    //             hidden: true
    //         },
    //     ],
    //     //show
    //     ...[
    //         {
    //             path: '/game/show',
    //             component: () => import('@/views/game/show/index'),
    //             hidden: true
    //         },
    //         {
    //             path: '/game/show_room',
    //             component: () => import('@/views/game/show/room'),
    //             hidden: true
    //         },
    //     ],
    //     //下载包
    //     ...[
    //         {
    //             path: '/download_package',
    //             component: () => import('@/views/down_ios_pack'),
    //             hidden: true
    //         }
    //     ]
    // ],
    //公众号/组件
    ...[
        // {
        //     //浏览器打开
        //     path: '/open',
        //     component: () => import('@/components/BrowserOpen'),
        //     hidden: true
        // },

        // {
        //     path: '/maintain',
        //     component: () => import('@/views/maintain'),
        //     meta: {
        //         title: '维修完成',
        //     },
        //     hidden: true
        // },
        {
            path: '/maintenanceEquipment',
            component: () => import('@/views/maintenanceEquipment'),
            meta: {
                title: '机修设备',
            },
            hidden: true
        },
        // {
        //     path: '/qr_code_xse',
        //     component: () => import('@/views/qr_code_xse'),
        //     meta: {
        //         title: '二维码已失效',
        //     },
        //     hidden: true
        // },
        // {
        //     path: '/video',
        //     component: () => import('@/views/video'),
        //     hidden: true
        // }
    ],
    //app嵌入页面
    // ...[
    //     // 申请合作
    //     {
    //         path: '/application_form',
    //         name: 'application_form',
    //         component: () => import('@/views/app/application_form')
    //     },
    // ]
]
const createRouter = () => new Router({
    // 路由切换
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
let router = createRouter()
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
}) 
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
